import { render } from "./Wysiwyg.vue?vue&type=template&id=2ab5e846"
import script from "./Wysiwyg.vue?vue&type=script&lang=js"
export * from "./Wysiwyg.vue?vue&type=script&lang=js"
script.render = render

export default script